// extracted by mini-css-extract-plugin
module.exports = {"root":"Timestamp-root-yb-30","text":"Timestamp-text-R1uiH"};